import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  
  private readonly appVersion = '3.1.1';
  private readonly qaVersion = '1';

  getApplicationVersion() {
    return environment.production 
      ? `v${this.appVersion}` 
      : `v${this.appVersion}.${this.qaVersion}`;
  }
}
